"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SubModule_1 = require("../SubModule");

var procedures_1 = require("../../../procedures");

var types_1 = require("../../../types");

var Offerings_1 = require("./Offerings");

var PolymathError_1 = require("../../../PolymathError");
/**
 * Namespace that handles all Issuance related functionality
 */


var Issuance =
/*#__PURE__*/
function (_SubModule_1$SubModul) {
  _inherits(Issuance, _SubModule_1$SubModul);

  /**
   * Create a new Issuance instance
   */
  function Issuance(securityToken, context) {
    var _this;

    _classCallCheck(this, Issuance);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Issuance).call(this, securityToken, context));
    /**
     * Issue a certain amount of tokens to an address. The address must already have been added via `modifyData`. Otherwise,
     * the corresponding tokenholder data for that address must be supplied to this method
     * **NOTE: If tokenholder data is supplied, client-side validations to verify if the transfer is possible won't be performed**
     *
     * @param args.issuanceData - array that specifies who to issue tokens to and which amounts. Can also contain KYC data
     */

    _this.issue = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var procedure;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                procedure = new procedures_1.IssueTokens(Object.assign({
                  symbol: this.securityToken.symbol
                }, args), this.context);
                return _context.abrupt("return", procedure.prepare());

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };
    /**
     * Permanently freeze issuance of the security token
     *
     * @param args.signature - optional signed data. If not passed, signing will be requested when the transaction queue is run. The data can be generated beforehand by the token owner calling `signFreezeAck`
     */


    _this.freeze = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                symbol = this.securityToken.symbol;
                procedure = new procedures_1.FreezeIssuance(Object.assign({}, args, {
                  symbol: symbol
                }), this.context);
                return _context2.abrupt("return", procedure.prepare());

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };
    /**
     * Generate a signature string that can be used to permanently freeze issuance of the Security Token
     *
     * **Note that only the owner's signature is valid for this operation**
     */


    _this.signFreezeAck = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                symbol = this.securityToken.symbol;
                procedure = new procedures_1.SignFreezeIssuanceAck({
                  symbol: symbol
                }, this.context);
                return _context3.abrupt("return", procedure.prepare());

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    };
    /**
     * Retrieve whether the issuance of tokens is allowed or not
     * Can be permanently frozen with `freeze`
     */


    _this.allowed = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var contractWrappers, symbol, tokenInstance;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                contractWrappers = this.context.contractWrappers, symbol = this.securityToken.symbol;
                _context4.prev = 1;
                _context4.next = 4;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 4:
                tokenInstance = _context4.sent;
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](1);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 10:
                return _context4.abrupt("return", tokenInstance.isIssuable());

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 7]]);
      }));
    };

    _this.offerings = new Offerings_1.Offerings(securityToken, context);
    return _this;
  }

  return Issuance;
}(SubModule_1.SubModule);

exports.Issuance = Issuance;